import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/qcenter-theme.css';
import App from './App';
import css from './App.css';
import reportWebVitals from './reportWebVitals';
import serialsJson from './data/serials.json';

const HTK_BACKEND = process.env.REACT_APP_HTK_BACKEND || window._env_.REACT_APP_HTK_BACKEND;
const HTK_ASSETS = process.env.REACT_APP_HTK_ASSETS || window._env_.REACT_APP_HTK_ASSETS;
const HTK_CDN = process.env.REACT_APP_HTK_CDN || window._env_.REACT_APP_HTK_CDN;
// const HTK_API_GOOGLE = process.env.REACT_APP_HTK_API_GOOGLE || window._env_.REACT_APP_HTK_API_GOOGLE;
// const HTK_CDN_SIMU = process.env.REACT_APP_HTK_CDN_SIMU || window._env_.REACT_APP_HTK_CDN_SIMU;

// const HTK_BACKEND = "https://qweb.hightek.it/";
// const HTK_ASSETS = "https://qcdn.hightek.it/";
// const HTK_CDN = "https://qcdn.hightek.it/v2/";
// const HTK_CDN_SIMU = "https://185.203.25.236:81/simu/v2/";
// const HTK_BACKEND = "http://qcenter.hightek.local:3500";
// const HTK_CDN = "http://185.203.25.236:81/simu/v2/";
// htkCDNSimu={HTK_CDN_SIMU}

ReactDOM.render(
  <React.StrictMode>
    <App
      sns={[]}
      htkCDN={HTK_CDN}

      htkBackend={HTK_BACKEND}
      htkAssets={HTK_ASSETS}
      htkApiMaps={"AIzaSyBS4-irfJhThd3xzM0cb1fFMKWMSA3pQ_g"}

      htkSimu = "SIMU-P020001/history.json"
      htkSimuSerial = ""
      snsJson = {serialsJson} timePolling={1000}
      startPosition = {[40.783712,14.698841]}
      htkBackendEmail={"https://qweb.hightek.it/sendMailQLive"}

      // // PREFISSO url streaming H265 (produzione)
      // htkVideoStreamingH265={"https://livestreaming.hightek.it/hightek"}

      // // PREFISSO url streaming H264 (produzione)
      // htkVideoStreamingH264={"https://livestreaming.hightek.it/h264/hightek"}

      // // PREFISSO url streaming Drone (produzione)
      // htkVideoStreamingDrone={"https://livestreaming.hightek.it/hightek"}

      // // PREFISSO url streaming Barca (produzione)
      // htkVideoStreamingBarca={"https://livestreaming.hightek.it/ecodrone"}

      // PREFISSO url streaming H265 (produzione)
      htkVideoStreamingH265={"https://dev-livestreaming.hightek.it/hightek"}

      // PREFISSO url streaming H264 (produzione)
      htkVideoStreamingH264={"https://dev-livestreaming.hightek.it/h264/hightek"}

      // PREFISSO url streaming Drone (produzione)
      htkVideoStreamingDrone={"https://dev-livestreaming.hightek.it/hightek"}

      // PREFISSO url streaming Barca (produzione)
      htkVideoStreamingBarca={"https://dev-livestreaming.hightek.it/ecodrone"}

      accessMode = {false}
      loadStreamingFromApi = {true}

      // Config seriali streaming: caricata da QCenter (/datalive/streamingConfig).
      // Riferimento storico: src/indexDiMezzo.js
      serialiStreaming = {[]}
      streamingH265 = {[]}
      streamingH264 = {[]}
      streamingDrone = {[]}
      streamingBarca = {[]}
      streamingSenzaSeqMission = {[]}

    />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
